var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2656 24.687L33.5312 43.112C35.1094 45.1575 38.1562 45.4674 40.3281 43.8093C42.5 42.1512 42.9844 39.1604 41.4062 37.1149L27.1406 18.6899L19.2656 24.687Z",
    fill: "#8CC947",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7715 32.7431C38.295 27.7769 39.5368 18.5227 34.5451 12.0733C29.5533 5.62385 20.2183 4.42149 13.6948 9.38772C7.1712 14.354 5.92943 23.6082 10.9212 30.0576C15.9129 36.507 25.2479 37.7094 31.7715 32.7431Z",
    fill: "white",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9648 20.7513C25.243 20.7513 27.0898 18.9197 27.0898 16.6603C27.0898 14.4009 25.243 12.5693 22.9648 12.5693C20.6867 12.5693 18.8398 14.4009 18.8398 16.6603C18.8398 18.9197 20.6867 20.7513 22.9648 20.7513Z",
    fill: "#8CC947",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0432 28.8406C29.4651 28.8406 29.8088 28.4842 29.7619 28.0812C29.3869 24.6876 26.4807 22.0532 22.9651 22.0532C19.4494 22.0532 16.5432 24.6876 16.1682 28.0812C16.1213 28.4842 16.4807 28.8406 16.8869 28.8406H29.0432Z",
    fill: "#8CC947",
    stroke: "#000105",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.286a71b9b30983c73fb4d992782baa4c.svg";
export { ForwardRef as ReactComponent };